<template>
  <div class="basic-setting">
    <el-popover placement="top-start" trigger="hover">
        <div id="qrDocument">
          <vue-qr
            :correctLevel="3"
            :autoColor="false"
            colorDark="#000000"
            :text="codeText"
            :callback="qrCodeCallback"
            :size="95"
            :margin="0"
            :logoMargin="3"
          ></vue-qr>
        </div>
      <el-button slot="reference" type="text" @click="downloadImg">PNG</el-button>
    </el-popover>
  </div>
</template>
<script>
import {levelApplyingFor} from '@/filters/index'
import VueQr from "vue-qr";
export default {
  props:{
    codeObject:{
      type:Object,
      default:()=>{
        return {}
      }
    }
  },
  data() {
    return {
      qrCodeUrl: ''
    }
  },
  computed: {
    codeText(){
      return this.setCodeText(this.codeObject)
    }
  },
  components: {
    VueQr,
  },
  methods: {
    setCodeText(val){
      let reApplicantName = ''
      if(val.applicantName){
        reApplicantName =  JSON.parse(val.applicantName)
      }
      let ret = ''
      ret += val.registrationNo + '#' + ' \n '
      ret += reApplicantName.en + '#' +' \n '
      ret += levelApplyingFor(val.formType)  + '#' + ' \n '
      ret += val.primaryContactPersonName + '#' + ' \n '
      ret += val.mobileNumber + '#' + ' \n '
      return  `${ret}`
    },
    qrCodeCallback (url) {
      this.qrCodeUrl = url
    },
    downloadImg() {
      var url = this.qrCodeUrl;
      // 创建一个a标签
      var a = document.createElement("a");
      var event = new MouseEvent("click");
      // 自定义下载二维码图片的名字
      a.download = "download二维码";
      //url地址
      a.href = url;
      //进行下载
      a.dispatchEvent(event);
    },
  },
};
</script>